module.exports = __webpack_public_path__ + "img/materiaux_techniques.5ba4d7c2.webp";